export default "__VITE_ASSET__c97a1c40__"